module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "poiStoreBig.79a998ce.svg";